/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2020-01-17 18:56:44
 * @LastEditTime : 2020-03-12 00:33:46
 * @LastEditors  : 山淑兰
 */
import { Get, Post, Pick } from "@/api/utils";
import {
  IInitSignUpSetUserConfig,
  IGetSignMeetingUser,
  IEditSignMeetingUser,
  IEditUserVouch,
  IInitSignUpInvoice,
  IEditUserInvoice,
  IVerSendMsg,
  ICheckModfiyUser,
  IModfiyPhone,
} from "./index.dto";

// const { API_HOST } = G_CONFIG;
const API_HOST = "";

export const PersonalCenterPath = {
  InitSignUpSetUserConfig: API_HOST + "/api/MeetingSign/InitSignUpSetUserConfig", //报名用户数据接口
  InitAddSignConfig: API_HOST + "/api/MeetingSign/InitAddSignConfig", //添加人员页面初始化接口
  GetSignMeetingUser: API_HOST + "/api/MeetingSign/GetSignMeetingUser", //获取报名用户信息接口
  EditSignMeetingUser: API_HOST + "/api/MeetingSign/EditSignMeetingUser", //修改报名信息接口
  UploadPic: API_HOST + "/api/File/UploadPic", //上传图片(支付凭证)接口
  EditUserVouch: API_HOST + "/api/MeetingSign/EditUserVouch", //修改支付凭证接口
  InitSignUpInvoice: API_HOST + "/api/MeetingSign/InitSignUpInvoice", //获取当前登录账户开票信息接口
  EditUserInvoice: API_HOST + "/api/MeetingSign/EditUserInvoice", //编辑发票信息
  Navigation: API_HOST + '/api/MeetingSign/InitMeetingNavigation', //底部导航栏接口
  userCentert: API_HOST + '/api/UserCenter/InitUserCentert', //个人中心获取个人信息接口
  checkModfiyUser: API_HOST + '/api/UserCenter/CheckModfiyUser', //验证绑定的手机号是否正确，并验证验证码
  modfiyPhone: API_HOST + '/api/UserCenter/ModfiyUserPhone', //修改手机号接口
  VER_SENDMSG: API_HOST + '/api/Ver/SendMsg', //发送验证码
};
export default {
  verSendMsg(body: IVerSendMsg) {
    const params = Pick(body, IVerSendMsg);
    return Post({
      url: PersonalCenterPath.VER_SENDMSG,
      params,
    });
  },
  /**验证绑定的手机号是否正确，并验证验证码*/
  checkModfiyUser(body: ICheckModfiyUser){
    const params = Pick(body, ICheckModfiyUser);
    return Post({
      url: PersonalCenterPath.checkModfiyUser,
      params,
    })
  },
  /**修改手机号接口*/
  modfiyPhone(body: IModfiyPhone){
    const params = Pick(body, IModfiyPhone);
    return Post({
      url: PersonalCenterPath.modfiyPhone,
      params,
    })
  },
  /**个人中心获取个人信息接口*/
  userCentert(body: IInitSignUpSetUserConfig){
    const params = Pick(body, IInitSignUpSetUserConfig);
    return Get({
      url: PersonalCenterPath.userCentert,
      params,
    })
  },
  /**
   * @title 底部导航栏接口
   */
  Navigation(body: IInitSignUpSetUserConfig){
    const params = Pick(body, IInitSignUpSetUserConfig);
    return Get({
      url: PersonalCenterPath.Navigation,
      params,
    });
  },
  /**
   * 报名用户数据接口
   */
  InitSignUpSetUserConfig(body: IInitSignUpSetUserConfig) {
    const params = Pick(body, IInitSignUpSetUserConfig);
    return Get({
      url: PersonalCenterPath.InitSignUpSetUserConfig,
      params,
    });
  },
  /**
   * 获取报名用户信息接口
   */
  GetSignMeetingUser(body: IGetSignMeetingUser) {
    const params = Pick(body, IGetSignMeetingUser);
    return Post({
      url: PersonalCenterPath.GetSignMeetingUser,
      params,
    });
  },
  /**
   * 修改报名信息接口
   */
  EditSignMeetingUser(body: IEditSignMeetingUser) {
    const params = Pick(body, IEditSignMeetingUser);
    return Post({
      url: PersonalCenterPath.EditSignMeetingUser,
      params,
    });
  },
  /**
   * 上传图片(支付凭证)接口
   */
  UploadPic(params: any) {
    return Post({
      url: PersonalCenterPath.UploadPic,
      params,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  /**
   * 修改支付凭证接口
   */
  EditUserVouch(body: IEditUserVouch) {
    const params = Pick(body, IEditUserVouch);
    return Post({
      url: PersonalCenterPath.EditUserVouch,
      params,
    });
  },
  /**
   * 获取当前登录账户开票信息接口
   */
  InitSignUpInvoice(body: IInitSignUpInvoice) {
    const params = Pick(body, IInitSignUpInvoice);
    return Get({
      url: PersonalCenterPath.InitSignUpInvoice,
      params,
    });
  },
  /**
   * 编辑发票信息
   */
  EditUserInvoice(body: IEditUserInvoice) {
    const params = Pick(body, IEditUserInvoice);
    return Post({
      url: PersonalCenterPath.EditUserInvoice,
      params,
    });
  },
};
